import React, { Component } from "react";
import { Row, Col, Steps, Popover } from "antd";
import { connect } from "react-redux";
import { AuthAction } from "../../store/actions";
import Register from "./register";
import Profile from "./profile";
import Personalize from "./personalize";
import AddPlant from "./Addplant";
import BuildMain from "./buildMain";
import Subscription from "./Subcription";
import { AiOutlineTwitter, FaFacebookF, FaInstagram } from "react-icons/all";
import RmxFooterImage from "../../assets/images/logo-sec1.png";
import RmxFooter from "../../assets/images/footer.png";
class SignUp extends Component {
  constructor(props) {
    super(props);
    this.state = {
      count: 0,
      userInfo: {},
    };
  }
  userData = (data) => {
    this.setState({
      userInfo: data,
    });
  };
  render() {
    const { count } = this.state;
    return (
      <Row>
        <Col span={24}>
          {count === 0 && (
            <Register
              count={count}
              onChangeStep={() =>
                this.setState({
                  count: this.state.count + 1,
                })
              }
              userData={this.userData}
            />
          )}

          {count === 1 && (
            <Profile
              count={count}
              onChangeStep={() =>
                this.setState({
                  count: this.state.count + 1,
                })
              }
              user={this.state.userInfo}
            />
          )}
          {count === 2 && (
            <AddPlant
              count={count}
              onChangeStep={() =>
                this.setState({
                  count: this.state.count + 1,
                })
              }
            />
          )}
          {count === 3 && (
            <Personalize
              count={count}
              onChangeStep={() =>
                this.setState({
                  count: this.state.count + 1,
                })
              }
            />
          )}
          {count === 4 && (
            <BuildMain
              count={count}
              onChangeStep={() =>
                this.setState({
                  count: this.state.count + 1,
                })
              }
            />
          )}
          {count === 5 && (
            <Subscription
              count={count}
              onChangeStep={() =>
                this.setState({
                  count: this.state.count + 1,
                })
              }
            />
          )}
        </Col>
        <Col span={24}>
          <Row>
            <Col
              xl={24}
              className="rmx-containers"
              style={{
                fontWeight: "500",
                backgroundImage: `url(${RmxFooter})`,
              }}
            >
              <Row className="rmx-footer-row" justify="center">
                <Col xl={6} className="rmx-footer">
                  <img src={RmxFooterImage} className="rmx-footer-image" />
                </Col>
                <Col xl={6} className="rmx-footer">
                  <Row gutter={[10, 20]}>
                    <Col xl={24} className="text-left">
                      CONTACT
                    </Col>
                    <Col xl={24} className="text-left">
                      {/* 402 W. Broadway Suite 400 San
                      <br />
                      Diego, CA 92101 */}
                      888 Prospect Street, Suite 200,
                      <br />
                      La Jolla, CA 92037
                    </Col>
                    <Col xl={24} className="text-left">
                      info@surface-tech.com
                      <br />
                      TEL: +1 619 880 0265
                    </Col>
                  </Row>
                </Col>
                <Col xl={6} className="rmx-footer">
                  {" "}
                  <Row gutter={[10, 20]}>
                    <Col xl={24} className="text-left">
                      TECHNOLOGY
                    </Col>
                    <Col xl={24} className="text-left">
                      ACE FIBRE
                    </Col>
                    <Col xl={24} className="text-left">
                      AQU FIBRE
                    </Col>
                    <Col xl={24} className="text-left">
                      CONCRETE
                    </Col>
                    <Col xl={24} className="text-left">
                      ETOOLS
                    </Col>
                  </Row>
                </Col>
                <Col
                  xl={6}
                  className="rmx-footer"
                  style={{ paddingBottom: "50px" }}
                >
                  <Row
                    justify="start"
                    align="bottom"
                    className="rmx-footer-icons"
                  >
                    <Col xl={4} className="pointer-cursor">
                      <AiOutlineTwitter color="#02B7A6" size="30" />
                    </Col>
                    <Col xl={4} className="pointer-cursor">
                      <FaFacebookF color="#02B7A6" size="30" />
                    </Col>
                    <Col xl={4} className="pointer-cursor">
                      <FaInstagram color="#02B7A6" size="30" />
                    </Col>
                  </Row>
                </Col>
              </Row>
              <Col className="rmx-copyright">
                <span
                  style={{
                    color: "#fff",
                  }}
                >
                  © 2021 Surface tech . All Rights Reserved.
                </span>
              </Col>
            </Col>
          </Row>
        </Col>
      </Row>
    );
  }
}

function mapStateToProps(storeState) {
  return {
    loader: storeState?.AuthReducer.loader,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    signup: (payload, cb) => dispatch(AuthAction.SignUp(payload, cb)),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(SignUp);
